<template>
  <div class="convert">
    <!--侧边栏-->
    <div class="convert-aside">
      <!--PDF转换-->
      <ul class="convert-aside-wrapper">
        <!--标题-->
        <li class="convert-aside-item convert-aside-title" style="pointer-events: none;">
          PDF转换
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/pdfConvert/pdfToWord"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            PDF转word
          </router-link>
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/pdfConvert/pdfToImage"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            PDF转图片
          </router-link>
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/pdfConvert/pdfToPPT"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            PDF转PPT
          </router-link>
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/pdfConvert/pdfToExcel"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            PDF转Excel
          </router-link>
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/pdfConvert/pdfToTxt"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            PDF转TXT
          </router-link>
        </li>
      </ul>
      <!-- 转换成PDF  -->
      <ul class="convert-aside-wrapper">
        <!--标题-->
        <li class="convert-aside-item convert-aside-title" style="pointer-events: none;">
          转换成PDF
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/convertToPdf/wordToPdf"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            Word转PDF
          </router-link>
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/convertToPdf/imageToPdf"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            图片转PDF
          </router-link>
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/convertToPdf/PPTToPdf"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            PPT转PDF
          </router-link>
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/convertToPdf/excelToPdf"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            Excel转PDF
          </router-link>
        </li>
      </ul>
      <!-- CAD转换  -->
      <ul class="convert-aside-wrapper">
        <!--标题-->
        <li class="convert-aside-item convert-aside-title" style="pointer-events: none;">
          CAD转换
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/cadConvert/pdfToCad"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            PDF转换CAD
          </router-link>
        </li>
        <li class="convert-aside-item">
          <router-link to="/convert/cadConvert/cadToPdf"
                       class="convert-aside-item-link"
                       active-class="convert-aside-item-active">
            CAD转换PDF
          </router-link>
        </li>
      </ul>
    </div>
    <router-view class="convert-content"></router-view>
  </div>
</template>

<script>
export default {
  name: 'Convert'
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/styleMixins";
  @import "../../assets/style/styleVariable";
  .convert{
    width: @page_width;
    display: flex;
    margin: 30px auto 70px auto;
    &-aside{
      width: 160px;
      margin-right: 30px;
      &-wrapper{
        display: flex;
        flex-direction: column;
      }
      &-item{
        height: 50px;
        background: #F9F9F9;
        cursor: pointer;
        &:hover{
          background-image: url('../../assets/images/hover_bg.png');
          background-size: 100% 100%;
        }
        &-active{
          background-image: url('../../assets/images/hover_bg.png');
          background-size: 100% 100%;
        }
        &-link{
          color: inherit;
          height: 100%;
          width: 100%;
          display: block;
          .flex_center_mixins;
        }
      }
      &-title{
        background: #548EF8;
        color: white;
        .flex_center_mixins;
      }
    }
    &-content{
      flex: 1;
    }
  }
</style>
